export default __webpack_public_path__ + "static/media/black-businessman-30.15383bf4.svg";